// extracted by mini-css-extract-plugin
export var burger = "Burger-module--burger--4ddfa";
export var root = "Burger-module--root--8777b";